export type ThemePreset = {
  id: string
  name: string
  primary: string
  recommendation: string
}

export const THEME_PRESETS: ThemePreset[] = [
  { id: 'galatea-navy', name: 'Galatea Navy', primary: '#1A237E', recommendation: 'Administrativo Geral' },
  { id: 'emerald-warehouse', name: 'Emerald Warehouse', primary: '#2E7D32', recommendation: 'WMS / Estoque' },
  { id: 'taxation-gold', name: 'Taxation Gold', primary: '#827717', recommendation: 'Fiscal / ICMS / IPI' },
  { id: 'bpa-cyber', name: 'BPA Cyber', primary: '#7B1FA2', recommendation: 'Automação e IA' },
  { id: 'slate-industrial', name: 'Slate Industrial', primary: '#455A64', recommendation: 'Operação de Longa Duração' },
  { id: 'deep-oceanic', name: 'Deep Oceanic', primary: '#01579B', recommendation: 'Logística e Fretes' },
  { id: 'ruby-accounting', name: 'Ruby Accounting', primary: '#B71C1C', recommendation: 'Financeiro / Auditoria' },
  { id: 'amber-logistics', name: 'Amber Logistics', primary: '#FF8F00', recommendation: 'Expedição / Rastreio' },
  { id: 'nordic-frost', name: 'Nordic Frost', primary: '#8EACBB', recommendation: 'Relatórios de Gestão' },
  { id: 'midnight-tech', name: 'Midnight Tech', primary: '#212121', recommendation: 'Dev Mode / Power Users' },
  { id: 'coffee-bean', name: 'Coffee Bean', primary: '#4E342E', recommendation: 'Compras e Insumos' },
  { id: 'vibrant-violet', name: 'Vibrant Violet', primary: '#6200EA', recommendation: 'CRM e Vendas' },
  { id: 'forest-edge', name: 'Forest Edge', primary: '#1B5E20', recommendation: 'Sustentabilidade' },
  { id: 'electric-blue', name: 'Electric Blue', primary: '#2979FF', recommendation: 'Monitoramento em Tempo Real' },
  { id: 'sunset-orange', name: 'Sunset Orange', primary: '#E65100', recommendation: 'Gestão de Risco' },
  { id: 'steel-grey', name: 'Steel Grey', primary: '#616161', recommendation: 'Cadastros Gerais' },
  { id: 'teal-serenity', name: 'Teal Serenity', primary: '#006064', recommendation: 'RH e Colaboradores' },
  { id: 'royal-purple', name: 'Royal Purple', primary: '#4A148C', recommendation: 'Dashboards de Diretoria' },
  { id: 'clay-terracotta', name: 'Clay Terracotta', primary: '#BF360C', recommendation: 'Chão de Fábrica' },
  { id: 'high-contrast', name: 'High Contrast', primary: '#000000', recommendation: 'Acessibilidade / Baixa Visão' },
]

